import React from 'react'

import SignalIntentCalculator from './SignalIntentCalculator'

const SavingsGoalCalculatorBlock = () => {
  return <SignalIntentCalculator Guid='51c85bb1-bbe5-4ec0-b50d-a2e3ade3868e' />
}

export default React.memo(SavingsGoalCalculatorBlock)
